import { render, staticRenderFns } from "./VehicleDetailReadings.vue?vue&type=template&id=79171072&scoped=true"
import script from "./VehicleDetailReadings.vue?vue&type=script&lang=js"
export * from "./VehicleDetailReadings.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetailReadings.vue?vue&type=style&index=0&id=79171072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79171072",
  null
  
)

export default component.exports